module.exports = __webpack_public_path__ + "img/BS09.70eae673.svg";